import React from 'react';
import { cn } from '../../lib/utils';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'left' | 'center';
  light?: boolean;
  className?: string;
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = 'left',
  light = false,
  className,
  as: Tag = 'h2'
}: SectionHeadingProps) {
  return <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)} data-id="element-471">
      {eyebrow && <p className={cn('mb-3 text-xs font-semibold uppercase tracking-[0.18em]', light ? 'text-brass-light' : 'text-brass-dark')} data-id="element-472">
          {eyebrow}
        </p>}
      <Tag className={cn('font-serif text-3xl font-500 leading-[1.12] tracking-tight sm:text-[2.4rem]', light ? 'text-cream' : 'text-navy')} data-id="element-473">
        {title}
      </Tag>
      {intro && <p className={cn('mt-4 text-lg leading-relaxed', light ? 'text-cream/75' : 'text-ink/70')} data-id="element-474">
          {intro}
        </p>}
    </div>;
}